import type { FormEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import type { SelectProps } from '@hotjar/hotsauce';

import { S } from './Styles';

interface OrganizationSelectorProps extends Omit<SelectProps, 'value' | 'children'> {
  value: number | undefined;
  onChange: FormEventHandler<HTMLSelectElement>;
  orgs: { id: number; name: string }[];
}

export const OrganizationSelector = ({
  value,
  onChange,
  orgs,
  ...rest
}: OrganizationSelectorProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <S.Select
      data-testid="team-invite-page-organization-selector"
      value={value}
      onChange={onChange}
      {...rest}
    >
      {!value && <option value="">{t('common:team-invite.select-org-placeholder')}</option>}
      {orgs.map((org) => (
        <option key={org.id} value={org.id}>
          {org.name}
        </option>
      ))}
    </S.Select>
  );
};
